import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5270fe22&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5270fe22&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270fe22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5270fe22')) {
      api.createRecord('5270fe22', component.options)
    } else {
      api.reload('5270fe22', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5270fe22&scoped=true&", function () {
      api.rerender('5270fe22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rule/bookMark/index.vue"
export default component.exports